module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@2x-e590777ce420b47795d9fdf65d6a7aff.png";